/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
campoExtraListDirectiva.$inject = [];
export default function campoExtraListDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'cargando': '=',
            'claseRow': '@'
        },
        template: require('./campos-extra-list.html'),
        controller: 'CamposExtraListCtrl as campExtList',
        bindToController: true
    }
}